import React from "react";
import "./bannerMessage.css";

const BannerMessage = ({ type = "info", text }) => {
	if (!text) return null;

	return (
		<div className={`sf-banner ${type}`}>
			<div className="sf-banner-text">{text}</div>
		</div>
	);
};

export default BannerMessage;